<template lang="html">
    <div class="container-fluid p-5">
        <div class="row mt-2">
            <div class="col-md-3">
                <div class="card" style="width: 100%;">
                     <div class="card-header">All Member</div>
                    <div class="card-body">
                        <p class="card-text">{{dashboard.all_member}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card" style="width: 100%;">
                     <div class="card-header">Today Bet Amount</div>
                    <div class="card-body">
                        <p class="card-text">{{dashboard.today_bet_amount}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card" style="width: 100%;">
                     <div class="card-header">Total Bet Amount</div>
                    <div class="card-body">
                        <p class="card-text">{{dashboard.total_bet_amount}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card" style="width: 100%;">
                     <div class="card-header">Total Commission</div>
                    <div class="card-body">
                        <p class="card-text">{{dashboard.total_commission}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import DashboardHeader from '@/components/DashboardHeader.vue'
    export default {
        name: 'dashboard',
        metaInfo: {
            title: "Home",
            titleTemplate: "%s ← BKK Dashboard",
        },
        components: {
            Loading,
            DashboardHeader
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                dashboard: [],
                user: null,
                copied: false,
            }
        },
        computed: {
            ...mapState({})
        },
        methods: {
            ...mapActions({
                dashboardAction: 'dashboardAction',
            }),
            copyAgentUrl() {
                const url = `https://ballxbet.com?agent=${this.user ? this.user.code : ''}`;
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(url).then(() => {
                        this.copied = true;
                        setTimeout(() => this.copied = false, 1500);
                    });
                } else {
                    // fallback for older browsers
                    const el = document.createElement('textarea');
                    el.value = url;
                    document.body.appendChild(el);
                    el.select();
                    document.execCommand('copy');
                    document.body.removeChild(el);
                    this.copied = true;
                    setTimeout(() => this.copied = false, 1500);
                }
            },
            async dashboardDetail() {
                this.isLoading = true;
                await this.dashboardAction().then(res => {
                    if (res.status == "success") {
                        this.dashboard = res.data
                        this.isLoading = false
                    }
                }).catch(err => this.isLoading = true)
            },
            toOrder(status) {
                this.$router.replace({ path: 'order-list', query: { page: 1, orderBy: 'desc', sortKey: 'created_at', limit: 10, fromDate: '', toDate: '', status: status, userId: '', email: '', orderNo: '' } }).catch(()=>{})
            },
        },
        async mounted() {
            this.isLoading = true
            const userStr = window.localStorage.getItem('user');
            if (userStr) {
                try {
                    this.user = JSON.parse(userStr);
                } catch (e) {
                    this.user = null;
                }
            }
            this.dashboardDetail()
        }
    }
</script>


<style scoped lang="scss">
    .dashboard-header {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background: linear-gradient(90deg, #2B3A42 0%, #4F8A8B 100%);
        border-radius: 12px;
        padding: 18px 32px;
        margin-bottom: 24px;
        box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
    }
    .dashboard-header h2 {
        color: #fff;
        font-size: 2rem;
        font-weight: 700;
        margin: 0;
        letter-spacing: 1px;
        text-shadow: 0 2px 8px rgba(44, 62, 80, 0.10);
    }
</style>